<script>
  import tippy from 'tippy.js';
  import { getContext, onMount, tick } from 'svelte';

  import { getProfileStore } from '@stores/profile';

  import UserAjax from '@ajax/user';
  import GroupCollectionAjax from '@ajax/group_collection';

  import PreloadBox from '@components/PreloadBox.svelte';
  import Text from '@components/Text.svelte';
  import Modal from '@components/Modal.svelte';

  import Profile from '@utils/profile';

  import ProfileHeader from './components/ProfileHeader.svelte';
  import ProfileStickyNavigation from './components/ProfileStickyNavigation.svelte';
  import AddButton from './components/AddButton.svelte';
  import ProfileCollection from './components/ProfileCollection.svelte';
  import ProfileCollectionBar from './components/ProfileCollectionBar.svelte';
  import UserSearchBar from './components/UserSearchBar.svelte';
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';
  import AdminInfo from './components/AdminInfo.svelte';
  import CreatorSpotlightModal from '@app-components/modal/CreatorSpotlightModal.svelte';
  import { browser } from '$app/environment';
  import queryString from 'query-string';
  import { inview } from 'svelte-inview';

  export let user;
  export let tablet;
  export let desktop;

  import jQuery from 'jquery';
  import UserFollowContent from '@app-components/modal/UserFollowContent.svelte';
  import LinktreeSocial from '@app-components/profile/LinktreeSocial.svelte';

  import CreatorScout from '@app-components/profile/CreatorScout.svelte';
  import Ambassador from '@app-components/profile/Ambassador.svelte';
  import HerCampus from '@app-components/profile/HerCampus.svelte';

  import { getCurrentUserStore } from '@stores/current_user';
  import Track from '@utils/track';
  import BlockedProfileContent from './BlockedProfileContent.svelte';

  let groupSortOrder = getProfileStore('groupSortOrder');
  let followCountStore = getProfileStore('followCountStore');
  let groupsStore = getProfileStore('groupsStore');
  let groupCollectionStore = getProfileStore('groupCollectionStore');
  let groupCollectionSortOrderStore = getProfileStore('groupCollectionSortOrderStore');
  let groupCollectionSortOrder = groupCollectionSortOrderStore;
  let currentUser = getCurrentUserStore('default');
  let allProfileGroupsLoaded = getContext('allProfileGroupsLoaded');

  let recsCount = 0;

  $: showAddBio = user.id === currentUser.id && recsCount > 2 && (user.bio == null || user.bio == '');

  $: showAddSocials = user.id === currentUser.id && recsCount > 2 && user.social_links && user.social_links.length == 0;

  $: loading = false;

  let loadingFollowers = false;

  let groups = groupsStore;
  let groupCollections = groupCollectionStore;

  $: if (groupCollectionSortOrder.length > 0) {
    groupCollections = groupCollectionStore.withSortOrderUnsortedFirst(groupCollectionSortOrder.map((x) => x.value));
  } else {
    groupCollections = groupCollectionStore;
  }

  let defaultCollection = groupCollections.find((x) => x.default_collection);

  let showProfileSearchBar = user.show_search_bar;

  let showFollowModal = false;
  let showCreatorSpotlightModal = false;
  let followModalContext;
  let followInfo;

  let followerDisabled;
  let followingDisabled;

  $: if (!currentUser.id) {
    followerDisabled =
      followInfo &&
      (followInfo.followerCount == 0 || (followInfo.followerCount < 50 && followInfo.followingCount == 0));
  } else {
    followerDisabled = followInfo && followInfo.followerCount == 0 && user.id != currentUser.id;
  }

  $: if (!currentUser.id) {
    followingDisabled = followInfo && followInfo.followingCount == 0;
  } else {
    followingDisabled = followInfo && followInfo.followingCount == 0 && user.id != currentUser.id;
  }

  let newCollectionCreated = async function (collection) {
    await tick();

    jQuery(`[data-group-collection-id="${collection.id}"]`).parent().find('.editable-content').focus();

    document.execCommand('selectAll', false, null);
  };

  let newGroupCreated = async function (group, collection = defaultCollection) {
    let ids = [group.id, ...Profile.sortOrderByPageIds(collection.id)];

    groupsStore.addFront(group);
    groupSortOrder.set(ids);
    collection.set({ ...collection, group_base_sort_order: ids });
    showNewGroupAnimation(group);

    UserAjax.update(user, {
      group_base_sort_order: ids,
    });

    GroupCollectionAjax.updateSortOrder(user, [
      {
        collection_id: collection.id,
        group_ids: ids,
      },
    ]);
  };

  let endOfPageReached = function () {
    Track.profilePageEndReached({ currentUser: currentUser, user: user });
  };

  let showNewGroupAnimation = async function (group) {
    await tick();

    let node = jQuery(`[data-group-id=${group.id}]`);

    node.addClass('new-profile-tile');
    var textElement = node.find('.group-name').find('.text-widget');
    textElement.focus();
    document.execCommand('selectAll', false, null);
    setTimeout(function () {
      node.removeClass('new-profile-tile');
    }, 3000);
  };

  let setupTippy = function () {
    tippy('[data-tippy-content]');
  };

  let followersClicked = function () {
    if (followerDisabled) {
      return;
    }
    followModalContext = 'followers';
    showFollowModal = true;
  };

  let followingClicked = function () {
    if (followingDisabled) {
      return;
    }
    followModalContext = 'following';
    showFollowModal = true;
  };

  let showFollowModalIfApplicable = function () {
    if (
      browser &&
      currentUser &&
      currentUser.id &&
      user &&
      user.id &&
      queryString.parse(location.search).followers == '1'
    ) {
      followersClicked();
    }
  };

  let showFollowingsModalIfApplicable = function () {
    if (
      browser &&
      currentUser &&
      currentUser.id &&
      user &&
      user.id &&
      queryString.parse(location.search).followings == '1'
    ) {
      followingClicked();
    }
  };

  let blockedUsers = getContext('blockedUsers');
  let userBlocked = false;
  $: {
    userBlocked = $blockedUsers.includes(user.id);
    showProfileSearchBar = !userBlocked;
  }

  onMount(() => {
    setupTippy();

    let sub = currentUser.subscribe((x) => (currentUser = x));

    let unsubGroups = groupsStore.subscribe((x) => {
      groups = x;
      let itemCount = 0;
      groups.forEach((g) => {
        itemCount += g.items_count;
      });
      recsCount = itemCount;
    });

    let unsubFollowInfo = followCountStore.subscribe((x) => {
      followInfo = x;
      loadingFollowers = x.isNew;
    });

    let unsubCollections = groupCollectionStore.subscribe((x) => {
      if (groupCollectionSortOrderStore.length > 0) {
        groupCollections = x.withSortOrderUnsortedFirst(groupCollectionSortOrderStore.map((x) => x.value));
      } else {
        groupCollections = x;
      }

      defaultCollection = groupCollections.find((x) => x.default_collection);
    });

    let unsubBlockedUsers = blockedUsers.subscribe((x) => {
      userBlocked = x.includes(user.id);
      showProfileSearchBar = !userBlocked;
    });

    showFollowModalIfApplicable();
    showFollowingsModalIfApplicable();

    return () => {
      sub();
      unsubGroups();
      unsubFollowInfo();
      unsubCollections();
      unsubBlockedUsers();
    };
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';
  .loading-box {
    height: 240px;
  }

  .profile-desktop {
    padding: 45px 90px;
    padding-top: 0px;
    max-width: 1360px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }

  .profile-container {
    display: grid;
    grid-template-columns: 1fr minmax(auto, 1000px) 1fr;
    grid-gap: 1rem;
    grid-template-areas: 'logo content actions';
  }

  .profile-content-container {
    grid-area: content;
  }

  .profile-data-container {
    text-align: center;
    line-height: 1.4;
  }

  .profile-data-heading {
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  .profile-data-meta {
    color: #808080;
  }

  .profile-data-follow-count {
    color: $neutral-gray;
    .count {
      font-weight: $font-weight-medium;
      color: $black;

      &.empty {
        font-weight: $font-weight-regular;
        color: $neutral-gray;
      }
    }

    .clickable {
      cursor: pointer;
      &:hover {
        color: #666;
      }
    }

    span + span {
      margin-left: 20px;
    }
  }

  .profile-data-social-links {
    margin-top: 16px;
    margin-bottom: 25px;

    .social-icons {
      a {
        svg {
          height: 24px;
          width: 24px;
        }
      }
    }
  }

  .add-social-links {
    @include typeface-b2($font-weight-semi-bold);
    color: $purple-60;
  }

  .profile-data-description {
    margin-top: 2rem;
    font-size: 16px;
    line-height: 24px;
    color: #808080;
    margin-bottom: 1rem;
  }

  .profile-sections-container {
    margin-top: 56px;
    margin-bottom: 180px;
  }

  .profile-sections-heading {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .profile-sections-heading-list-count {
    font-size: 14px;
    font-weight: 400;
    color: #808080;
    margin-left: 8px;
  }

  .loading-groups {
    display: grid;
    grid-template-columns: repeat(3, 320px);
    grid-gap: 20px;
    margin-top: 24px;
  }

  .purple-box {
    display: flex;
    margin-top: 22px;
    border-radius: 15px;
    padding: 28px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    background: #f9f6ff;
    padding-top: 60px;
    padding-bottom: 60px;
    min-height: 350px;

    .ui-text-create {
      color: #a893f9;
      margin-top: 20px;
      line-height: 1.4;
      font-size: 20px;
      font-weight: 500;
    }

    .ui-text {
      line-height: 1.4;
      font-size: 20px;
      font-weight: 500;
      margin-top: 40px;
    }
  }

  @media only screen and (max-width: 1345px) {
    .profile-container {
      display: grid;
      grid-template-columns: 495px 495px;
      grid-gap: 1rem;
      grid-template-areas:
        'logo actions'
        'content content';
    }
  }

  .tablet {
    .draggable-groups {
      grid-template-columns: repeat(auto-fill, 320px);
    }
  }

  @media only screen and (max-width: 1170px) {
    .tablet {
      &.profile-container {
        grid-template-columns: 325px 325px;
      }
      .draggable-groups {
        grid-template-columns: repeat(auto-fill, 320px);
      }
    }
  }

  * :global(.follow-modal) {
    max-width: 660px !important;
    padding-bottom: 0 !important;
    padding-top: 0px !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  * :global(.follow-modal .modal__content) {
    margin-top: 10px;
    margin-bottom: 0px;
  }

  .account-name-header {
    font-size: 30px;
    font-weight: 700;
    margin-top: 0px;
    margin-bottom: 0px;
    line-height: 42px;
  }

  .creator-spotlight-button {
    background: none;
    font-weight: 500;
    border: none;
    color: #000;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: 200ms;

    svg {
      margin-top: 2px;
    }
    &:hover {
      color: #a893f9;
    }
  }
</style>

{#if showFollowModal}
  <div class="svelte-modal follow-modal">
    <Modal
      mobile={false}
      on:close={() => {
        showFollowModal = false;
      }}
      show={showFollowModal}
      showCloseButton={false}
      fadeInDuration={200}
      containerClass={'follow-modal'}>
      <div slot="content">
        <UserFollowContent
          profileUser={user}
          currentUser={currentUser}
          context={followModalContext}
          on:close={() => {
            showFollowModal = false;
          }} />
      </div>
    </Modal>
  </div>
{/if}

{#if showCreatorSpotlightModal}
  <CreatorSpotlightModal
    mobile={false}
    user={user}
    clickContext={'more_about_me'}
    bind:showModal={showCreatorSpotlightModal}
    on:close={() => {
      showCreatorSpotlightModal = false;
    }} />
{/if}

{#if !userBlocked}
  <ProfileStickyNavigation
    user={user}
    tablet={tablet}
    on:added-group={(e) => {
      newGroupCreated(e.detail.group);
    }}
    on:added-collection={(e) => {
      newCollectionCreated(e.detail.collection);
    }} />
{/if}

<div class="profile-desktop">
  <div class="profile-container" class:desktop={desktop} class:tablet={tablet}>
    <div class="profile-content-container">
      {#if user && currentUser && currentUser.user_flag}
        <AdminInfo user_id={user.id} />
      {/if}
      {#if user}
        <ProfileHeader user={user} userBlocked={userBlocked} />
      {/if}
      <div class="profile-data-container">
        <div class="profile-data-heading">
          <AccountVerifiedIcon
            dimension={20}
            verified={user.verified}
            extraStyle={user.verified ? 'justify-content: center; padding-left: 30px;' : 'justify-content: center;'}
            extraStyleIcon={'margin-top:3px;'}>
            <svelte:fragment slot="account-name">
              <h1 class="account-name-header">{user.name}</h1>
            </svelte:fragment>
          </AccountVerifiedIcon>
        </div>

        {#if loadingFollowers || !browser}
          <div class="profile-data-placeholder" style="height: 21px" />
        {:else if followerDisabled && followingDisabled}
          <div class="profile-data-meta">{user.join_date}</div>
        {:else}
          <div class="profile-data-follow-count">
            <span class={followerDisabled ? '' : 'clickable'} on:click={followersClicked}>
              {#if followInfo}
                {#if currentUser.id}
                  <span class="count {followInfo.followerCount == 0 ? 'empty' : ''}">{followInfo.followerCount}</span>
                  follower{followInfo.followerCount != 1 ? 's' : ''}
                {:else}
                  <a
                    on:click|preventDefault={followersClicked}
                    href={user.profile_path + '/followers'}
                    class="count {followInfo.followerCount == 0 ? 'empty' : ''}">{followInfo.followerCount}</a>
                  follower{followInfo.followerCount != 1 ? 's' : ''}
                {/if}
              {/if}
            </span>
            <span class={followingDisabled ? '' : 'clickable'} on:click={followingClicked}>
              {#if followInfo}
                {#if currentUser.id}
                  <span class="count {followInfo.followingCount == 0 ? 'empty' : ''}">{followInfo.followingCount}</span>
                {:else}
                  <a
                    on:click|preventDefault={followingClicked}
                    href={user.profile_path + '/following'}
                    class="count {followInfo.followingCount == 0 ? 'empty' : ''}">{followInfo.followingCount}</a>
                {/if}
              {/if}
              following
            </span>
          </div>
        {/if}
        <div class="profile-data-social-links">
          {#if showAddBio}
            <a href="/profiles/edit?show_bio=true" class="add-social-links"
              ><img
                alt="plus-icon"
                src={`/images/save-button/plus.svg`}
                style="width: 8px; height: 8px; vertical-align: middle; margin-bottom: 3px; margin-right: 3px" />Add bio</a>
          {:else if showAddSocials}
            <a href="/profiles/edit?click_social_link=true" class="add-social-links"
              ><img
                alt="plus-icon"
                src={`/images/save-button/plus.svg`}
                style="width: 8px; height: 8px; vertical-align: middle; margin-bottom: 3px; margin-right: 3px" />Add
              your socials</a>
          {:else if user.social_links && user.social_links.length > 0}
            <div class="social-icons">
              {#each user.social_links as sl}
                <a
                  on:click={(event) => {
                    event.preventDefault();
                    Track.profileSocialLinkClicked({
                      currentUser: currentUser,
                      user: user,
                      path: location.pathname,
                      linkDomain: sl.link_type,
                      link: sl.url,
                    });
                    window.open(sl.url);
                  }}
                  target="_blank"
                  data-tippy-content={sl.label}
                  href={sl.url}
                  rel="nofollow"
                  style="margin-left: 8px; margin-right: 8px; width: 24px; height:
    24px; padding-top: 8px; padding-left: 3px;">
                  <img src={`/images/profile/socials/${sl.link_type}.svg`} style="width: 24px; height: 24px;" />
                </a>
              {/each}
            </div>
          {/if}

          <LinktreeSocial />
        </div>

        {#if user.ambassador}
          <div class="profile-data-ambassador"><Ambassador /></div>
        {:else if user.her_campus}
          <div class="profile-data-her-campus"><HerCampus herCampus={user.her_campus} /></div>
        {:else if user.creator_scout}
          <div class="profile-data-creator-scout"><CreatorScout /></div>
        {/if}

        <div class="profile-data-description" style="min-height: 24px">
          <Text text={user.bio} editable={false} lines={4} />
        </div>
        {#if user.spotlight_active}
          <button
            class="creator-spotlight-button"
            on:click={() => {
              showCreatorSpotlightModal = true;
            }}>
            <span>More about me</span>
            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.67383 1.06486C3.40866 1.4361 3.45165 1.98784 3.76986 2.29721L7.57846 6L3.76986 9.70279C3.45165 10.0122 3.40866 10.5639 3.67383 10.9351C3.93901 11.3064 4.41193 11.3565 4.73014 11.0472L9.23014 6.67219C9.40113 6.50595 9.5 6.25968 9.5 6C9.5 5.74032 9.40113 5.49405 9.23014 5.32781L4.73014 0.952828C4.41193 0.64346 3.93901 0.693619 3.67383 1.06486Z"
                fill="#7F7F7F" />
            </svg>
          </button>
        {/if}
      </div>
      {#if userBlocked}
        <BlockedProfileContent user={user} />
      {:else}
        <div class="profile-sections-container">
          {#if showProfileSearchBar}
            <UserSearchBar focus={false} user={user} />
          {/if}
          <div class="profile-sections-heading">
            {#if user.id != currentUser.id || groups.length > 0 || !currentUser.has_group_possible_ideas}
              <div>
                {user.name}{user.name && user.name[user.name.length - 1].toLowerCase() === 's' ? "' Lists" : "'s Lists"}
                <span class="profile-sections-heading-list-count">
                  {#if !loading && browser && $allProfileGroupsLoaded}
                    {groups.length}
                  {/if}
                </span>
              </div>
            {/if}
            {#if !loading && user.id === currentUser.id}
              <span style={groups.length === 0 ? 'visibility: hidden' : ''}>
                <AddButton
                  on:added-group={(e) => {
                    newGroupCreated(e.detail.group);
                  }}
                  on:added-collection={(e) => {
                    newCollectionCreated(e.detail.collection);
                  }} />
              </span>
            {/if}
          </div>

          <div>
            <ProfileCollectionBar tablet={tablet} user={user} />
          </div>

          {#if loading}
            <div class="loading-groups">
              <div class="group-container loading-box">
                <PreloadBox />
              </div>
              <div class="group-container loading-box">
                <PreloadBox />
              </div>

              {#if desktop}
                <div class="group-container loading-box">
                  <PreloadBox />
                </div>
                <div class="group-container loading-box">
                  <PreloadBox />
                </div>
              {/if}
            </div>
          {:else if groups.length === 0 && !user.permissions.edit}
            <div class="purple-box">
              <img src="/images/sparkles.png" />

              <div class="ui-text">
                {user.name} doesn't have any public lists yet
              </div>
            </div>
          {:else}
            {#each groupCollections as groupCollection (groupCollection.id)}
              {#if user.permissions.edit || groupsStore.findByIds(groupCollection.group_base_sort_order).length > 0}
                <ProfileCollection
                  id={groupCollection.id}
                  user={user}
                  on:new-duplicate-created={(e) => newGroupCreated(e.detail.group)}
                  on:added-group={(e) => {
                    newGroupCreated(e.detail.group, e.detail.collection);
                  }} />
              {/if}
            {/each}
          {/if}
        </div>
      {/if}
      {#if !loading}
        <div use:inview={{}} on:enter={endOfPageReached} />
      {/if}
    </div>
  </div>
</div>
